import { Grid, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Iconify from "../components/Iconify";

// Define password conditions with updated requirements
const passwordConditions = [
    {
        key: "passwordMinLengthRequired",
        test: (password) => password?.length >= 12,
    },
    {
        key: "passwordLowercaseRequired",
        test: (password) => /[a-z]/.test(password),
    },
    {
        key: "passwordUppercaseRequired",
        test: (password) => /[A-Z]/.test(password),
    },
    {
        key: "passwordDigitRequired",
        test: (password) => /\d/.test(password),
    },
    {
        key: "passwordSymbolRequired",
        test: (password) => /[.!@#$%^&*]/.test(password),
    },
];

const PasswordHint = ({ password = "" }) => {

    const { t } = useTranslation();

    return (
        <Grid container spacing={2}>
            {passwordConditions?.map((condition) => {
                const isMet = condition.test(password);
                return (
                    <Grid item xs={12} sm={6} key={condition.key}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Iconify
                                icon={isMet ? "mdi:check-circle" : "radix-icons:dot-filled"}
                                sx={{ color: isMet ? "#2ecc40" : "#b0b0b0", fontSize: 24 }}
                            />
                            <Typography variant="body2" sx={{ color: isMet ? "#2ecc40" : "#757575" }}>{t(condition.key)}</Typography>
                        </Box>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default PasswordHint;